import { inject } from '@angular/core';
import { IAuthService } from '@app/auth/interfaces/auth-service.interface';
import { AuthMsalService } from '@app/auth/msal/services/auth-msal.service';
import { AuthOktaService } from '@app/auth/okta/services/auth-okta.service';
import { authProviders } from '@auth/constants/auth-provider.constant';
import { APP_CONFIG } from '@avenir-client-web/models';
import { AppConfig } from '@core/models/config.models';

/**
 * Factory function that returns the appropriate authentication service
 * based on the provider specified in the application configuration.
 *
 * @returns IAuthService - Either AuthMsalService (for Entra) or AuthOktaService (for Okta)
 */
export function authServiceFactory(): IAuthService {
  const config = inject(APP_CONFIG) as AppConfig;

  switch (config.auth.provider) {
    case authProviders.Okta:
      return inject(AuthOktaService);
    case authProviders.Entra:
      return inject(AuthMsalService);
    default:
      throw new Error(`Unsupported auth provider: ${config.auth.provider}`);
  }
}
